import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const TransFaq = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div className='container transparencia-container'>
            <div className='row'>
                <div className='col-12'>
                    <div className='transparencia_title'>
                        <h1>Preguntas frecuentes</h1>
                        <hr className="tramitehr" />
                        <h2>Donación</h2>
                    </div>
                    <div className="row">
          <div className="col-12" >
<div class="accordion" id="accordionConoce">
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingOne">
      <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
        1) ¿Qúe es la donación de Órganos y tejidos?
      </button>
    </h2>
    <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionConoce">
      <div class="accordion-body">
      Es la manifestación de la voluntad de una persona, ya sea tácita o expresa, para que en vida o a la perdida de esta, su cuerpo o cualquiera de sus órganos y/o tejidos se utilicen con fines de trasplante. (Artículo 231 de Ley General de Salud).
      </div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingTwo">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
        2) ¿Qué significa la donación tácita
      </button>
    </h2>
    <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionConoce">
      <div class="accordion-body">
      Se refiere a que la persona no manifestó en vida su negativa de que sus órganos sean utilizados para trasplantes después de su muerte y de acuerdo a la prelación señalada en la ley, se requiera que el familiar que se encuentre presente, otorgue su consentimiento. (Artículo 325 Ley General de Salud).
      </div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingThree">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
        3) ¿A qué se refiere la Donación expresa?
      </button>
    </h2>
    <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionConoce">
      <div class="accordion-body">
      Se refiere a que la persona manifieste su deseo verbal o escrito de SER DONADOR. Si es escrito, El Centro Nacional de Trasplantes ofrece dos posibilidades:
      <ul>
        <li>La “Tarjeta de Donador Voluntario"</li>
        <li>El “Documento Oficial de la donación”</li>
      </ul>
      La Tarjeta de donador Voluntario se puede conseguir de igual manera en Centros Estatales de Trasplantes.
      El “Documento Oficial de la Donación” debe ser expedido por una autoridad Federal facultada para tal efecto (Centro Nacional de Trasplantes) debiendo acudir de manera personal a recibir su documento con previa identificación.
      </div>
    </div>
  </div>
    <div class="accordion-item">
    <h2 class="accordion-header" id="headingFour">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
        4) ¿Existe un Documento para expresar mi deseo de "No" donar?
      </button>
    </h2>
    <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionConoce">
      <div class="accordion-body">
      Si, la “Negativa de donación de órganos y tejidos para después de la muerte”, expedida por el Centro Nacional de Trasplantes.
      Se considera la manifestación expresa del donante de que no está de acuerdo con la disposición de sus órganos y/ o tejidos en un documento público o privado debidamente firmado. (Artículo 324, segundo párrafo LGS).
      </div>
    </div>
  </div>
      <div class="accordion-item">
    <h2 class="accordion-header" id="headingFive">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapsefive">
        5) ¿Que puedo Donar en vida?
      </button>
    </h2>
    <div id="collapseFive" class="accordion-collapse collapse" aria-labelledby="headingFive" data-bs-parent="#accordionConoce">
      <div class="accordion-body">
      Puedo donar un órgano o parte de él que al ser extraído su función pueda ser compensada por el organismo del donante de forma adecuada y suficientemente segura. Esto es un Riñón, Médula ósea y Sangre.
      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="headingSix">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
        6) ¿Qué necesito para donar en vida?
      </button>
    </h2>
    <div id="collapseSix" class="accordion-collapse collapse" aria-labelledby="headingSix" data-bs-parent="#accordionConoce">
      <div class="accordion-body">
     <ul>
      <li>Ser mayor de edad y estar en pleno uso de sus facultades mentales.</li>
      <li>Tener compatibilidad aceptable con el receptor, el consentimiento podrá SER REVOCABLE EN CUALQUIER MOMENTO.</li>
      <li>Recibir información completa sobre los riesgos de la operación y las consecuencias de la extracción del órgano o tejido, por un médico distinto de los que intervendrán en el trasplante.</li>
      <li>Haber otorgado su consentimiento en forma expresa (artículos 322 y 323 de la Ley General de Salud).</li>
     </ul>
      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="headingSeven">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
        7) ¿Qué puedo donar después de mi fallecimiento?
      </button>
    </h2>
    <div id="collapseSeven" class="accordion-collapse collapse" aria-labelledby="headingSeven" data-bs-parent="#accordionConoce">
      <div class="accordion-body">
      Si es pérdida de la vida por PARO CARDÍACO, se pueden donar tejidos: Córneas, piel, hueso, cartílago, tendones, válvulas cardíacas y vasos sanguíneos.
      Si es Pérdida de la vida por MUERTE ENCEFÁLICA se puede donar, además de los tejidos ya mencionados; ÓRGANOS, Corazón, pulmones, hígado, ambos riñones y páncreas.
      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="headingEight">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEight" aria-expanded="false" aria-controls="collapseEight">
        8) ¿Qué es la muerte encefálica?
      </button>
    </h2>
    <div id="collapseEight" class="accordion-collapse collapse" aria-labelledby="headingEight" data-bs-parent="#accordionConoce">
      <div class="accordion-body">
      Es la pérdida permanente e irreversible de la conciencia, respuesta a estímulos sensoriales y ausencia de respiración espontánea, ocurre cuando tallo y corteza cerebral están destruidos y no hay posibilidad de devolverle la vida.
      Para su diagnóstico por ley se debe de corroborar mediante estudios que demuestren la ausencia de actividad eléctrica cerebral (ELECTROENCEFALOGRAMA) o de flujo sanguíneo cerebral. (Ej. Angiotomografía Cerebral, Doppler Transcraneal.)

      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="headingNine">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseNine" aria-expanded="false" aria-controls="collapseNine">
        9) ¿Que hago para poder ser donador después de mi muerte?
      </button>
    </h2>
    <div id="collapseNine" class="accordion-collapse collapse" aria-labelledby="headingNine" data-bs-parent="#accordionConoce">
      <div class="accordion-body">
      Posterior a haber tomado la decisión de donar, compartirla con tu familia ya que al fallecer, ellos serán los encargados de cumplir tu voluntad.
      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="headingTen">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTen" aria-expanded="false" aria-controls="collapseTen">
        10) ¿Quién se encarga de solicitar la donación de los órganos y tejidos?
      </button>
    </h2>
    <div id="collapseTen" class="accordion-collapse collapse" aria-labelledby="headingTen" data-bs-parent="#accordionConoce">
      <div class="accordion-body">
      El COORDINADOR HOSPITALARIO DE DONACIÓN es quien informa a la familia sobre la posibilidad de la donación, le solicita la autorización, la acompaña y orienta durante el proceso. Dicho coordinador deberá :
      <ul>
      <li className='list-mark'>a) Comprobar que se ha dictaminado el fallecimiento de la persona por el médico tratante, NO por el médico responsable de realizar el trasplante.</li>
      <li className='list-mark'>b) Cerciorarse de que el cuerpo de esa persona reúna las condiciones médicas necesarias para ser donante.</li>
      <li className='list-mark'>c) Tener presente que la familia es la depositaria final del deseo de su ser querido que ha fallecido.</li>
      </ul>
      Ellos pueden otorgar la anuencia para que se cumpla el deseo de su familiar, a fin de brindar con la donación, la posibilidad de mejorar la vida de otras personas que esperan un trasplante.

      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="headingEleven">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEleven" aria-expanded="false" aria-controls="collapseEleven">
        11) Si decido donar mis órganos ¿recibo alguna retribución?
      </button>
    </h2>
    <div id="collapseEleven" class="accordion-collapse collapse" aria-labelledby="headingEleven" data-bs-parent="#accordionConoce">
      <div class="accordion-body">
      La donación es un acto de generosidad y total altruismo de una persona, no debe estar condicionada.
      Este acto es reconocido en días y semanas nacionales que conmemoran la donación.
      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="headingTwelve">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwelve" aria-expanded="false" aria-controls="collapseTwelve">
        12) ¿Al extraer los órganos que han sido donados el cuerpo del donante es maltratado?
      </button>
    </h2>
    <div id="collapseTwelve" class="accordion-collapse collapse" aria-labelledby="headingTwelve" data-bs-parent="#accordionConoce">
      <div class="accordion-body">
      No, en el proceso de obtención de los órganos se realiza en un quirófano con la mayor dignificación del cuerpo, esto es que al final de la intervención quirúrgica se deja el cuerpo del donante en las mejores condiciones para ser entregado a la familia.
      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="headingThirteen">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThirteen" aria-expanded="false" aria-controls="collapseThirteen">
        13) ¿Puedo donar si tengo tatuajes?
      </button>
    </h2>
    <div id="collapseThirteen" class="accordion-collapse collapse" aria-labelledby="headingThirteen" data-bs-parent="#accordionConoce">
      <div class="accordion-body">
      Si, deben de haber pasado como mínimo 6 meses del último tatuaje, en esas circunstancias el médico determinará si es viable donar, considerando algunos factores de riesgo, como la presencia de algunas enfermedades.
      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="headingFourteen">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFourteen" aria-expanded="false" aria-controls="collapseFourteen">
        14) Si yo he decidido ser donante de órganos, despues de mi muerte ¿Mi familia podrá decidir lo contrario?
      </button>
    </h2>
    <div id="collapseFourteen" class="accordion-collapse collapse" aria-labelledby="headingFourteen" data-bs-parent="#accordionConoce">
      <div class="accordion-body">
      Si, por eso es de suma importancia que tu decisión de ser donador sea un tema platicado previamente con tu familia ya que ellos tendrán en dado caso la decisión final.
      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="headingFiveteen">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFiveteen" aria-expanded="false" aria-controls="collapseFiveteen">
        15) ¿De qué me sirve la tarjeta de donador voluntario?
      </button>
    </h2>
    <div id="collapseFiveteen" class="accordion-collapse collapse" aria-labelledby="headingFiveteen" data-bs-parent="#accordionConoce">
      <div class="accordion-body">
      La tarjeta de donador voluntario es un documento con valor moral, que expresa tu deseo de ser donador, sin embargo a pesar de haberla firmado, al momento de tu fallecimiento siempre se le pedirá la autorización a tu familia, por eso es importante que al obtenerla lo comentes con tus seres queridos.
      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="headingSixteen">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSixteen" aria-expanded="false" aria-controls="collapseSixteen">
        16) ¿Qué es un transplante?
      </button>
    </h2>
    <div id="collapseSixteen" class="accordion-collapse collapse" aria-labelledby="headingSixteen" data-bs-parent="#accordionConoce">
      <div class="accordion-body">
      Es la transferencia de un órgano, tejido o células, de un individuo a otro, para sustituir la función del órgano dañado (Artículo 314, fracción XIV, LGS).
      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="headingSeventeen">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeventeen" aria-expanded="false" aria-controls="collapseSeventeen">
        17) ¿Qué Órganos o Tejidos se pueden donar?
      </button>
    </h2>
    <div id="collapseSeventeen" class="accordion-collapse collapse" aria-labelledby="headingSeventeen" data-bs-parent="#accordionConoce">
      <div class="accordion-body">
      Órganos: Corazón Hígado, Pulmones, Riñones y Páncreas.
      Tejidos: Córneas, Piel, Medula Ósea, Hueso, Cartílago, Tendones, Válvulas Cardiacas, Arterias y Venas.
      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="headingEighteen">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEighteen" aria-expanded="false" aria-controls="collapseEighteen">
        18) ¿Cuánto tiempo viven los órganos una vez que se han extraído del cuerpo de una persona que ha perdido la vida?
      </button>
    </h2>
    <div id="collapseEighteen" class="accordion-collapse collapse" aria-labelledby="headingEighteen" data-bs-parent="#accordionConoce">
      <div class="accordion-body">
      El Corazón, Los Pulmones y El Hígado aproximadamente de 4 a 6 horas para que se realice el trasplante y tenga éxito.
      Los Riñones aproximadamente 12 horas.
      Las Córneas aproximadamente hasta 14 días ya que pueden ser conservadas en bancos de tejidos que están autorizados por la COFEPRIS.
      Los huesos después de pasar por un proceso complejo de preparación y así poder ser conservados en bancos de tejidos, que están autorizados por la COFEPRIS
      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="headingNineteen">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseNineteen" aria-expanded="false" aria-controls="collapseNineteen">
        19) ¿Quienes necesitan de un transplante?
      </button>
    </h2>
    <div id="collapseNineteen" class="accordion-collapse collapse" aria-labelledby="headingNineteen" data-bs-parent="#accordionConoce">
      <div class="accordion-body">
      Personas quienes padecen de alguna insuficiencia orgánica irreversible y en quienes recibir un órgano es la óptima alternativa de tratamiento para recuperar su calidad de vida.
      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="headingTwenty">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwenty" aria-expanded="false" aria-controls="collapseTwenty">
        20) Transplante entre Personas vivas, ¿Entre quienes se pueden realizar?
      </button>
    </h2>
    <div id="collapseTwenty" class="accordion-collapse collapse" aria-labelledby="headingTwenty" data-bs-parent="#accordionConoce">
      <div class="accordion-body">
      Los trasplantes se realizarán, de preferencia, entre personas que tengan parentesco por consanguinidad (Padres, hijos, abuelos), civil (Adoptado y Adoptante) o de afinidad (Estar unidos por matrimonio o concubinato). Si no existe un parentesco es posible realizar una donación siempre y cuando:
      <ul>
      <li>Se obtenga resolución favorable del Comité de Trasplantes de la institución hospitalaria donde se vaya a realizar el trasplante, previa evaluación médica, clínica y psicológica;</li>
      <li> El interesado en donar deberá otorgar su consentimiento expreso ante NOTARIO PÚBLICO manifestando que ha recibido información completa sobre el procedimiento por médicos autorizados, así como precisar que el consentimiento es altruista, libre, consciente y sin que medie remuneración alguna. El consentimiento PODRÁ SER REVOCABLE EN CUALQUIER MOMENTO.</li>
      <li>Comprobar que no se está lucrando con esa práctica.</li>
      </ul>
      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="headingTwentyOne">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwentyOne" aria-expanded="false" aria-controls="collapseTwentyOne">
        21) ¿Qué debo hacer si requiero un transplante?
      </button>
    </h2>
    <div id="collapseTwentyOne" class="accordion-collapse collapse" aria-labelledby="headingTwentyOne" data-bs-parent="#accordionConoce">
      <div class="accordion-body">
      Acudir con el Médico Tratante encargado de llevar su proceso terapéutico, al término del estudio, determinará la viabilidad del Trasplante, y será registrado en la Base de datos por un profesional de la salud, de forma gratuita, integrante del Comité Interno de Trasplantes del Hospital.
      Si es candidato a Trasplante , Se le expedirá una constancia de inscripción en donde se especifican los datos generales del paciente, sin que se pierda de vista que la asignación de Órganos y tejidos no atiende al orden de registro de los pacientes que el Comité Interno de Trasplantes del Hospital determinará.
      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="headingTwentyTwo">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwentyTwo" aria-expanded="false" aria-controls="collapseTwentyTwo">
        22) ¿Cuáles son los criterios de asignación de órganos?
      </button>
    </h2>
    <div id="collapseTwentyTwo" class="accordion-collapse collapse" aria-labelledby="headingTwentyTwo" data-bs-parent="#accordionConoce">
      <div class="accordion-body">
      Artículo 336 Ley General de Salud
      <li>Gravedad del receptor</li>
      <li>Oportunidad del trasplante</li>
      <li>Beneficios esperados</li>
      <li>Compatibilidad con el receptor</li>
      <li>Antigüedad en el Registro</li>
      <li>La ubicación hospitalaria e institución del donador La ubicación Hospitalaria e institución del Donador.</li>
      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="headingTwentyThree">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwentyThree" aria-expanded="false" aria-controls="collapseTwentyThree">
        23) ¿Por qué debo tomar en cuenta donar mis órganos?
      </button>
    </h2>
    <div id="collapseTwentyThree" class="accordion-collapse collapse" aria-labelledby="headingTwentyThree" data-bs-parent="#accordionConoce">
      <div class="accordion-body">
      Es muy importante tener una mentalidad donadora, ya que cada día ingresan más mexicanos a registros de espera de un órgano y necesitan de un trasplante para seguir viviendo con una mejor calidad de vida.
      </div>
    </div>
  </div>

</div>
          </div>
      </div>

                </div>
            </div>

        </div>
    )
}

export default TransFaq
